module.exports = __webpack_public_path__ + "img/qrcode2.c7b63b61.jpg";